// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"7b6252be","549":"2f202332"}[chunkId] + ".chunk.js";
};